var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"name":"NB Carnes","navLinks":[
      {
        name: 'Início',
        link: '#home',
        dropdown: false,
      },

      {
        name: 'Sobre',
        link: '#about',
        dropdown: false,
      },

      {
        name: 'Princípios',
        link: '#principles',
        dropdown: false,
      },

      {
        name: 'Galeria',
        link: '#galery',
        dropdown: false,
      },
      {
        name: 'Área Restrita',
        link: 'https://nbcarnes.com.br/sistema/view/login.php',
        dropdown: false,
      } ]}}),_c('router-view'),_c('Whatsapp'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }